import { useState, useMemo } from "react";
import { motion } from "framer-motion";
import ComissaoService from "../../services/resource/ComissaoService";
import { toast } from "react-toastify";

// ─── Exportação Tab ───────────────────────────────────────────────────────────
function ExportacaoTab({ ano, mes, role, filialId }) {
    const comissaoService = useMemo(() => new ComissaoService(), []);

    const [loadingDA, setLoadingDA] = useState(false);
    const [loadingDL, setLoadingDL] = useState(false);

    const FileDownload = require('js-file-download');

    // DA = distribuidor autorizado, DL = distribuidor logístico: cada planilha leva só o seu e só quem tem valor a receber
    const exportar = async (tipo) => {
        const isDA = tipo === "DA";
        isDA ? setLoadingDA(true) : setLoadingDL(true);
        const filial = role ? filialId : null;

        comissaoService.exportar({
            ano, mes,
            tipoDistribuidor: isDA ? "AUTORIZADO" : "LOGISTICO",
            filialId: filial,
        }).then(res => {
            FileDownload(res.data, `Comissoes ${tipo} ${ano}-${String(mes).padStart(2, "0")}.xlsx`);
        }).catch(e => {
            toast.error(e?.message || e?.response?.data?.message || "Erro ao exportar as comissões.");
        }).finally(() => {
            isDA ? setLoadingDA(false) : setLoadingDL(false);
        });
    };

    const cards = [
        {
            tipo: "DA",
            label: "Distribuidor Autorizado",
            description: "Comissões dos distribuidores autorizados (só quem tem valor a receber), com o resumo para o RH e os romaneios de quem recebe.",
            icon: "fa fa-user-circle",
            color: "blue",
            loading: loadingDA,
        },
        {
            tipo: "DL",
            label: "Distribuidor Logístico",
            description: "Comissões dos distribuidores logísticos (só quem tem valor a receber), com cubagem, conclusão + Green Mile, retorno e o resumo para o RH.",
            icon: "fa fa-truck",
            color: "teal",
            loading: loadingDL,
        },
    ];

    const colorMap = {
        blue: {
            wrapper: "border-blue-200 bg-blue-50/40",
            icon: "bg-blue-100 text-blue-600",
            badge: "bg-blue-100 text-blue-700",
            button: "bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300",
        },
        teal: {
            wrapper: "border-teal-200 bg-teal-50/40",
            icon: "bg-teal-100 text-teal-600",
            badge: "bg-teal-100 text-teal-700",
            button: "bg-teal-600 hover:bg-teal-700 disabled:bg-teal-300",
        },
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            className="p-6 max-w-2xl mx-auto"
        >
            {/* Período selecionado */}
            <div className="flex items-center gap-2 mb-6 text-sm text-muted-foreground">
                <i className="fa fa-calendar text-muted-foreground" />
                <span>Período selecionado:</span>
                <span className="font-semibold text-foreground">
                    {mes}/{ano}
                </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {cards.map(({ tipo, label, description, icon, color, loading }) => {
                    const c = colorMap[color];
                    return (
                        <div
                            key={tipo}
                            className={`rounded-2xl border p-5 shadow-card flex flex-col gap-4 transition-shadow duration-150 ${c.wrapper}`}
                        >
                            <div className="flex items-center gap-3">
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg ${c.icon}`}>
                                    <i className={icon} />
                                </div>
                                <div>
                                    <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${c.badge}`}>
                                        {tipo}
                                    </span>
                                    <p className="font-semibold text-sm text-foreground mt-0.5">{label}</p>
                                </div>
                            </div>

                            <p className="text-xs text-muted-foreground leading-relaxed">{description}</p>

                            <button
                                onClick={() => exportar(tipo)}
                                disabled={loading}
                                className={`w-full flex items-center justify-center gap-2 py-2 rounded-xl text-white text-xs font-semibold transition-colors duration-150 disabled:cursor-not-allowed ${c.button}`}
                            >
                                {loading ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin" />
                                        Exportando...
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-file-excel-o" />
                                        Exportar {tipo}
                                    </>
                                )}
                            </button>
                        </div>
                    );
                })}
            </div>
        </motion.div>
    );
}

export default ExportacaoTab;